import { render, staticRenderFns } from "./damageSpareParts.vue?vue&type=template&id=af10b1ac&scoped=true"
import script from "./damageSpareParts.vue?vue&type=script&lang=js"
export * from "./damageSpareParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af10b1ac",
  null
  
)

export default component.exports